module.exports = __webpack_public_path__ + "img/15.85f953d1.jpg";